// extracted by mini-css-extract-plugin
module.exports = {"url":"fetchDetails_url_3X_-N5q","status":"fetchDetails_status_1Dy7lmu"};